module.exports = __webpack_public_path__ + "static/media/hero-mobile.e0991681.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-mobile.webp
// module id = 199
// module chunks = 51